import { graphql } from '../../gql';

export const ROLE_TAXONOMY_VERSIONS_QUERY = graphql(`
  query RoleTaxonomyVersions {
    roleTaxonomies {
      taxonomyId
      taxonomyName
      version
      isLatest
    }
  }
`);
